import { parseTimestamp } from './dateUtils'

/** Default page size — must match backend default for `limit`. */
export const CHAT_SESSIONS_PAGE_SIZE = 10

export type ApiSessionRow = Record<string, unknown>

export function parseSessionsEnvelope(json: unknown): { sessions: ApiSessionRow[]; has_more: boolean } {
  if (Array.isArray(json)) {
    return { sessions: json as ApiSessionRow[], has_more: false }
  }
  const o = json as { sessions?: unknown; has_more?: unknown }
  const sessions = Array.isArray(o.sessions) ? (o.sessions as ApiSessionRow[]) : []
  return { sessions, has_more: o.has_more === true }
}

export async function fetchChatSessionsPage(
  apiBase: string,
  offset: number,
  signal?: AbortSignal
): Promise<{ sessions: ApiSessionRow[]; has_more: boolean }> {
  const res = await fetch(
    `${apiBase}chat/sessions?limit=${CHAT_SESSIONS_PAGE_SIZE}&offset=${offset}`,
    { credentials: 'include', signal }
  )
  if (!res.ok) throw new Error('Failed to load sessions')
  const json = await res.json()
  return parseSessionsEnvelope(json)
}

/** Maps one API session row into the chat UI `ChatHistory` shape. */
export function mapApiSessionToChatHistory(s: ApiSessionRow): {
  id: string
  title: string
  messages: Array<{
    id: string
    content: string
    sender: 'user' | 'aira'
    timestamp: Date
    is_edited?: string
    original_content?: string
    edited_at?: Date
    file_path?: string
    file_name?: string
    file_size?: string
  }>
  timestamp: Date
  created_at?: string
  sessionModelId?: string
} {
  const history = Array.isArray(s.history) ? s.history : []
  const mn = s.model_name
  return {
    id: String(s.id),
    title: (typeof s.name === 'string' ? s.name : '') || 'New Chat',
    sessionModelId: typeof mn === 'string' && mn.trim() ? mn.trim() : undefined,
    messages: (history as Record<string, unknown>[]).map(h => ({
      id: String(h.id ?? ''),
      content: String(h.content ?? ''),
      sender: h.role === 'user' ? 'user' : 'aira',
      timestamp: h.timestamp ? parseTimestamp(String(h.timestamp)) : new Date(),
      is_edited: h.is_edited as string | undefined,
      original_content: h.original_content as string | undefined,
      edited_at: h.edited_at ? new Date(String(h.edited_at)) : undefined,
      file_path: h.file_path as string | undefined,
      file_name: h.file_name as string | undefined,
      file_size: h.file_size != null ? String(h.file_size) : undefined,
    })),
    timestamp: s.created_at ? new Date(`${String(s.created_at)}Z`) : new Date(),
    created_at: typeof s.created_at === 'string' ? s.created_at : undefined,
  }
}
